import { Grid, Box, Chip } from '@mui/material';
import ShowChartRoundedIcon from '@mui/icons-material/ShowChartRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { BaseCard } from '../common/BaseCard';
import { DataItem } from '../common/DataItem';
import { ConsultaOnlineButton } from '../common/ConsultaOnlineButton';
import { formatDateSafe, formatDataComprovanteReceita } from '../utils/formatters';
import { ISituacaoCadastralPF, ISituacaoCadastralPJ } from '../../../../../../application/models/dossie';
import { useDossieService } from '../../../../../../use-cases/dossie';

export const SituacaoCadastralCard = ({
  isPF,
  documento,
  dataNascimento,
  dataAbertura,
}: {
  situacaoCadastral?: ISituacaoCadastralPF | ISituacaoCadastralPJ | null;
  isPF: boolean;
  documento: string;
  dataNascimento?: string;
  dataAbertura?: string;
}) => {
  const {
    situacaoCadastralAtiva,
    situacaoCadastralOnline,
  } = useDossieService();

  if (!situacaoCadastralAtiva) return null;

  const pfCad = isPF ? (situacaoCadastralAtiva as ISituacaoCadastralPF) : null;
  const pjCad = !isPF ? (situacaoCadastralAtiva as ISituacaoCadastralPJ) : null;

  const descSituacao = isPF
    ? pfCad?.DescricaoSituacaoCadastral
    : pjCad?.situacaoCadastral?.DescricaoSituacaoCadastral;

  const dataInscricao = isPF
    ? formatDateSafe(pfCad?.DataInscricao)
    : formatDateSafe(pjCad?.situacaoCadastral?.DataSituacaoCadastral);

  const dataComprovante = isPF
    ? formatDataComprovanteReceita(pfCad?.DataHoraEmissaoComprovante)
    : formatDataComprovanteReceita(
        pjCad?.dadosEmpresa?.DataHoraEmissaoComprovante ||
        pjCad?.situacaoCadastral?.DataConsulta
      );

  const headerActions = (
    <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
      <ConsultaOnlineButton
        documento={documento}
        dataNascimento={dataNascimento}
        dataAbertura={dataAbertura}
      />
    </Box>
  );

  return (
    <BaseCard
      title="Situação na Receita Federal"
      icon={<ShowChartRoundedIcon />}
      headerAction={headerActions}
    >
      {situacaoCadastralOnline && (
        <Box mb={2} display="flex" alignItems="center">
          <Chip
            icon={<CheckCircleRoundedIcon sx={{ fontSize: '15px !important', color: '#2e7d32 !important' }} />}
            label="Exibindo dados obtidos via Consulta Online na Receita Federal"
            size="small"
            sx={{
              bgcolor: '#e8f5e9',
              color: '#2e7d32',
              fontWeight: 600,
              fontSize: '0.75rem',
              borderRadius: '6px',
            }}
          />
        </Box>
      )}

      <Grid container spacing={2.5} className="situacao-cadastral-grid">
        {isPF ? (
          <>
            <Grid item xs={12} sm={6} md={3} lg={2.5} className="sit-col-1">
              <DataItem label="Situação Cadastral" value={descSituacao} />
            </Grid>
            <Grid item xs={12} sm={6} md={2.5} lg={2} className="sit-col-2">
              <DataItem label="Data de Inscrição" value={dataInscricao} />
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={1.5} className="sit-col-3">
              <DataItem
                label="Dígito Verificador"
                value={pfCad?.DigitoVerificador || '-'}
                preserveCase={true}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4.5} lg={3} className="sit-col-4">
              <DataItem label="Data e Hora do Comprovante" value={dataComprovante} />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={3} className="sit-col-5">
              <DataItem
                label="Código do Comprovante"
                value={pfCad?.CodigoControleComprovante || '-'}
                preserveCase={true}
              />
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} sm={6} md={4} className="sit-pj-col">
              <DataItem label="Situação Cadastral" value={descSituacao} />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="sit-pj-col">
              <DataItem label="Data de Inscrição" value={dataInscricao} />
            </Grid>
            <Grid item xs={12} sm={12} md={4} className="sit-pj-col">
              <DataItem label="Data da Consulta" value={dataComprovante} />
            </Grid>
          </>
        )}
      </Grid>
    </BaseCard>
  );
};
